import { useCallback, useEffect, useRef, useState } from 'react';

export function useCroppedPreview(image: string | undefined) {
	const [croppedPreviewUrl, setCroppedPreviewUrl] = useState<string | undefined>();
	const prevCroppedUrlRef = useRef<string | undefined>(undefined);
	const [prevImage, setPrevImage] = useState(image);

	if (prevImage !== image) {
		setPrevImage(image);
		setCroppedPreviewUrl(undefined);
	}

	const handleCroppedPreviewChange = useCallback((url: string) => {
		if (prevCroppedUrlRef.current) URL.revokeObjectURL(prevCroppedUrlRef.current);
		prevCroppedUrlRef.current = url;
		setCroppedPreviewUrl(url);
	}, []);

	useEffect(() => {
		return () => {
			if (prevCroppedUrlRef.current) {
				URL.revokeObjectURL(prevCroppedUrlRef.current);
				prevCroppedUrlRef.current = undefined;
			}
		};
	}, [image]);

	return { croppedPreviewUrl, handleCroppedPreviewChange };
}
